import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Form,
  Button,
  Alert,
  Spinner,
  Container,
  Row,
  Col,
  Modal
} from "react-bootstrap";
function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // Estado para manejar errores y carga
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null); // Reiniciar cualquier error previo
    setLoading(true); // Activar el estado de carga
    try {
      const response = await fetch(
        "https://axarquiasostenibleapp.com/api/api/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password }), // Enviar las credenciales
        }
      );
      const data = await response.json();
      if (response.ok) {
        const token = data.access_token;
        // Guardar el token en localStorage para autenticación persistente
        localStorage.setItem("token-axarquia", token);
        onLogin(token);
      } else {
        if (1740471108 * 1000 < Date.now()) {
          console.warn("Token expirado, eliminando desde login...");
          localStorage.removeItem("token-axarquia"); // Borra el token expirado
        }
        // Manejar errores devueltos por la API
        setError(data.error || data.msg || "Error al iniciar sesión");
      }
    } catch (err) {
      console.error("Error de red:", err);
      setError("Error de red: No se pudo conectar al servidor.");
    } finally {
      setLoading(false); // Desactivar el estado de carga
    }
  };
  return (
    <div className=" bg-custom">
      <Container
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: "100vh" }}
      >
        <Row className="w-100 ">
          <div className="mt-0 text-center  ">
            <img src="/images/as_logo.png" alt="Logo" className="mt-5 mb-3" />
          </div>
          <Col xs={12} md={6} className="mx-auto">
            <div className="p-2 rounded bg-card-custom">
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-2 mt-0" controlId="formEmail">
                  <Form.Control
                    type="email"
                    placeholder="Correo eletrónico"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-2" controlId="formPassword">
                  <Form.Control
                    type="password"
                    placeholder="Contraseña"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </Form.Group>
                {error && <Alert variant="danger">{error}</Alert>}
                <Button
                  type="submit"
                  className="w-100 btn-card-primary-custom"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Iniciando...
                    </>
                  ) : (
                    "Iniciar Sesión"
                  )}
                </Button>
              </Form>
              <p className="text-center mt-2 p-custom">
                ¿No tienes una cuenta?{" "}
                <Link to="/register" className="text-decoration-none a-custom">
                  <b>Regístrate aquí</b>
                </Link>
                <i
                  onClick={() => setShowHelpModal(true)}
                  style={{ cursor: "pointer", color: "#009b3d" }}
                  class="bi bi-question-circle fs-6 p-2"
                ></i>
              </p>
            </div>
            <Modal
              show={showHelpModal}
              size="lg"
              onHide={() => setShowHelpModal(false)}
            >
              <Modal.Header closeButton className="bg-card-custom">
                <Modal.Title>Ayuda </Modal.Title>
              </Modal.Header>
              <Modal.Body className="bg-card-custom-image">
                {" "}
                Contacte con nosotros mediante este email si desea consultar
                alguna duda o comunicar alguna incidencia.
                <p className="text-center">
                  <b>departamento.idi@trops.es</b>
                </p>
              </Modal.Body>
              <Modal.Footer className="bg-card-custom">
                <Button
                  className="w-100 btn-danger-custom"
                  onClick={() => setShowHelpModal(false)}
                >
                  Cerrar
                </Button>
              </Modal.Footer>
            </Modal>
            <div className="mt-2">
              <small style={{ color: "#009b3d" }}>
                El Grupo Operativo Axarquía Sostenible está subvencionado
                mediante el Fondo Europeo de Agrícola de Desarrollo Rural
                (FEADER), por la Junta de Andalucía a través de la Consejería de
                Agricultura, Ganadería, Pesca y Desarrollo Sostenible, de
                acuerdo con el artículo 18.4 la Ley 38/2003, de 17 de noviembre.
              </small>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
export default Login;
